export default __webpack_public_path__ + "static/media/sapphire1a.0e34865e.png";